import { useEffect, useState } from "react";
import AdminNavbar from "./AdminNavbar";
import { db } from "../Firebase";

export default function Enquiries() {

    const [data, setdata] = useState([]);
    const [selectedEnquiry, setSelectedEnquiry] = useState(null);

    function fetchdata() {
        db.collection("form").onSnapshot((succ) => {
            setdata(succ.docs);
        })
    }

    useEffect(() => {
        fetchdata();
    }, [])

    return (
        <>
            <div className="bg-light min-vh-100">
                <AdminNavbar />
                <div className="container-fluid px-4 py-1">
                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-2 gap-2">
                        <div>
                            <h4 className="mb-0">Enquiry Management</h4>
                            <p className="text-muted">
                                {/* {cat.length}  */}
                                Enquiries
                            </p>
                        </div>
                    </div>
                    <div className="card shadow-sm mx-3">
                        <div className="card-body container-fluid px-0">
                            <div className="table-responsive-sm table-responsive-md" style={{ maxHeight: "500px", overflowY: "auto" }}>
                                <table className="table table-hover align-middle text-nowrap">
                                    <thead>
                                        <tr>
                                            <th>NAME</th>
                                            <th>CONTACT</th>
                                            <th>EMAIL</th>
                                            <th>AGE</th>
                                            <th>WEIGHT</th>
                                            <th>GOAL</th>
                                            <th>PROGRAM</th>
                                            <th>MESSAGE</th>
                                            <th>DATE</th>
                                            <th>STATUS</th>
                                            <th>ACTIONS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((row) => (
                                            <>
                                                <tr>
                                                    <td>{row.data().name}</td>
                                                    <td>{row.data().phone}</td>
                                                    <td>{row.data().email}</td>
                                                    <td>{row.data().age}</td>
                                                    <td>{row.data().weight}</td>
                                                    <td>{row.data().goal}</td>
                                                    <td>{row.data().program}</td>
                                                    <td>
                                                        {row.data().message.slice(0, 30) + "..."}
                                                    </td>
                                                    <td>{row.data().Date}</td>
                                                    <td>{row.data().status}</td>
                                                    <td>
                                                        <button className="btn btn-primary py-1 text-light me-2" data-bs-toggle="modal" data-bs-target="#mymod" onClick={() => setSelectedEnquiry(row)}>
                                                            View
                                                        </button>
                                                    </td>
                                                </tr>
                                            </>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal fade" id="mymod" tabIndex="-1">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Enquiry Details</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            {selectedEnquiry && (
                                <>
                                    <div className="row">
                                        <div className="col-lg-6 col-12">
                                            <p><strong>Name:</strong> {selectedEnquiry.data().name}</p>
                                            <p><strong>Contact:</strong> {selectedEnquiry.data().phone}</p>
                                            <p><strong>Email:</strong> {selectedEnquiry.data().email}</p>
                                            <p><strong>Age:</strong> {selectedEnquiry.data().age}</p>
                                        </div>
                                        <div className="col-lg-6 col-12">
                                            <p><strong>Weight:</strong> {selectedEnquiry.data().weight}</p>
                                            <p><strong>Goal:</strong> {selectedEnquiry.data().goal}</p>
                                            <p><strong>Program:</strong> {selectedEnquiry.data().program}</p>
                                            <p><strong>Date:</strong> {selectedEnquiry.data().Date}</p>
                                        </div>
                                    </div>
                                    <p><strong>Message:</strong> {selectedEnquiry.data().message}</p>
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}